import { connect } from 'react-redux';
import React from 'react';
import PlayIcon from '@mui/icons-material/PlayArrowRounded';
import PauseIcon from '@mui/icons-material/PauseRounded';
import { Button } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { createActions } from '../../store';
import { RealtimeAudioAnalyzer } from '../../Audio/RealtimeAudioAnalyzer';
import { GlobalAudioEventListeners } from '../../Audio/helpers/GlobalAudioEventListeners';

const styles = theme => ({
    controlButton: {
        minWidth: 0,
        padding: theme.spacing(1),
        borderRadius: 100,
        color: '#fff'
    }
});

class AudioPlayPauseButton extends React.Component {
    render() {
        const { classes, playingPreview, disabled } = this.props;

        return (
            <Button
                color='primary'
                variant='contained'
                className={classes.controlButton}
                onClick={this.onPlayPauseButtonClick}
                aria-label={(playingPreview ? 'Pause' : 'Play') + ' preview'}
                disabled={disabled}
                id='play-button'
            >
                {playingPreview 
                    ? <PauseIcon /> 
                    : <PlayIcon />
                }
            </Button>
        );
    }

    onPlayPauseButtonClick = () => {
        const { playingPreview, setPlayingPreview } = this.props;
        setPlayingPreview(!playingPreview);
    }

    componentDidMount() {
        const { setProperty } = this.props;
        let self = this;

        GlobalAudioEventListeners.onPlaying((event) => {
            setProperty('audioWaiting', false);
        });

        GlobalAudioEventListeners.onWaiting((event) => {
            if (self.props.volume !== 0)
                setProperty('audioWaiting', true);
        });
    }

    componentDidUpdate(prevProps) {
        const { playingPreview } = this.props;
        const { playingPreview: prevPlayingPreview } = prevProps;

        if (playingPreview !== prevPlayingPreview) {
            if (playingPreview) {
                RealtimeAudioAnalyzer.play();
            }
            else {
                RealtimeAudioAnalyzer.pause();
            }
        }
    }
}

const mapStateToProps = (state) => {
    const {
        playingPreview
    } = state.create;

    return {
        playingPreview
    }
};

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(createActions.setProperty(key, value));
    const setPlayingPreview = (playingPreview) => dispatch(createActions.setPlayingPreview(playingPreview));

    return {
        setProperty,
        setPlayingPreview
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(AudioPlayPauseButton, styles));